import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { TransferPanelModule } from 'shared/components/transfer-panel/transfer-panel.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { ChatMessagesModule } from 'shared/components/chat-messages/chat-messages.module';
import { FileUploadService } from 'common/api/file-upload-service';
import { ChatBoxComponent } from './chat-box.component';
import { WrapUpPanelModule } from '../../shared/components/wrapup-panel/wrap-up-panel.module';
import { ChatButtonsComponent } from './chat-buttons/chat-buttons.component';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { FileUploadBoxModule } from './file-upload-box/file-upload-box.module';
import { AlertBoxModule } from 'shared/components/alert-box/alert-box.module';
import { SmartResponsesModule } from '../../shared/components/smart-responses/smart-responses.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ngfModule } from 'angular-file';
import { WorkWidgetControlPanelModule } from 'shared/components/work-widget-control-panel/work-widget-control-panel.module';
import { ChatMessagesQueueService } from 'common/chat-messages-queue/chat-messages-queue.service';
import { TinyMCEEditorModule } from 'shared/components/editor/editor.module';
import { FileUploadPickerModule } from 'shared/components/file-upload-picker/file-upload-picker.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { JoinChatModule } from 'shared/components/join-chat/join-chat.module';
import { ChatActionsModule } from 'shared/components/chat-actions/chat-actions.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { WorkItemWidgetSharedModule } from '../../shared/work-item-widget-shared.module';
import { FlagModule } from 'shared/components/flag/flag.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    CustomPipesModule,
    SvgIconModule,
    LoadingModule,
    TransferPanelModule,
    ChatMessagesModule,
    VisitorHistoryModule,
    WrapUpPanelModule,
    TooltipModule,
    FileUploadBoxModule,
    AlertBoxModule,
    SmartResponsesModule,
    VirtualScrollerModule,
    FormsModule,
    EditorModule,
    ngfModule,
    WorkWidgetControlPanelModule,
    TinyMCEEditorModule,
    FileUploadPickerModule,
    AutoSaveModule,
    JoinChatModule,
    ChatActionsModule,
    WorkItemWidgetSharedModule,
    FlagModule
  ],
  providers: [
    FileUploadService,
    ChatMessagesQueueService
  ],
  declarations: [
    ChatButtonsComponent,
    ChatBoxComponent
  ],
  exports: [
    ChatBoxComponent
  ]
})
export class ChatBoxModule {}
